import React from "react";
import { BirdIcon, BookOpenIcon, CandyIcon, CherryIcon, CloudLightningIcon, CoinsIcon, CrosshairIcon, CrownIcon, FishIcon, GemIcon, MicIcon, MoonIcon, PickaxeIcon, PyramidIcon, SkullIcon, SparklesIcon, TrainFrontIcon, TreesIcon, ZapIcon, BoxIcon } from "lucide-react";
import { Slot, SlotTheme } from "../types/slot";
const themeIcons: Record<SlotTheme, BoxIcon> = {
  myth: ZapIcon,
  book: BookOpenIcon,
  egypt: PyramidIcon,
  candy: CandyIcon,
  bird: BirdIcon,
  space: SparklesIcon,
  fish: FishIcon,
  jungle: TreesIcon,
  western: CrosshairIcon,
  train: TrainFrontIcon,
  princess: CrownIcon,
  mine: PickaxeIcon,
  wolf: MoonIcon,
  frog: MicIcon,
  jackpot: CoinsIcon,
  thunder: CloudLightningIcon,
  fruit: CherryIcon,
  horror: SkullIcon,
  gem: GemIcon
};
const sizes = {
  sm: {
    box: 'h-12 w-12 rounded-lg',
    icon: 'h-5 w-5',
    text: 'text-[9px]'
  },
  md: {
    box: 'h-16 w-16 rounded-xl',
    icon: 'h-7 w-7',
    text: 'text-[10px]'
  },
  lg: {
    box: 'h-28 w-28 rounded-2xl',
    icon: 'h-11 w-11',
    text: 'text-xs'
  }
};
export function SlotThumb({
  slot,
  size = 'md'
}: {
  slot: Slot;
  size?: keyof typeof sizes;
}) {
  const Icon = themeIcons[slot.theme];
  const s = sizes[size];
  return <div className={`relative flex shrink-0 items-center justify-center overflow-hidden ${s.box}`} style={{
    backgroundColor: slot.color
  }} aria-hidden="true" data-id="element-361" data-mp="2pyh1c4xiucn7">
      <Icon className={`${s.icon} text-white`} strokeWidth={1.75} data-id="element-362" data-mp="3hnsk1h16j0d5" />
      <span className={`absolute bottom-1 left-0 right-0 text-center font-semibold uppercase tracking-wide text-white/80 ${s.text}`} data-id="element-363" data-mp="3hqetjm7mrpy0">
        {slot.reels.split(' ')[0]}
      </span>
    </div>;
}